import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

import { UserDropdownComponentConfigurator } from './user-dropdown-component.configurator';
import { BaseMultiselectDropdownComponent } from '@pl/pl-lib/forms';
import { User } from 'src/app/core/models/user';

@Component({
  selector: 'app-user-multiselect-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/multiselect-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/multiselect-dropdown.component.scss'
  ]
})
export class UserMultiselectDropdownComponent extends BaseMultiselectDropdownComponent<User> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new UserDropdownComponentConfigurator();
  }
}
